import React from 'react'
import { getExtension } from '../../../../helpers/helpers'
import { useDispatch } from 'react-redux'
import { showDocumentViewerModalFunc } from '../../../../config/redux/slice/bankUserSlice'
import { image_extensions } from '../../../../constants/english'

export default function DocumentViewerModal({filePath}) {
    const dispatch = useDispatch()
  return (
    <div 
    onClick={()=>{dispatch(showDocumentViewerModalFunc({modal: false, url: ''}))}}
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div style={{backgroundColor: 'transparent', border: 'none'}} className="modal-content">
      <div className='d-flex justify-content-center'>
        {image_extensions.includes((getExtension(filePath)).toLowerCase()) ? 
            <img className='certificate-img-modal' src={filePath} alt='certificate'/> 
            :
            <iframe style={{width: '90%'}} className='certificate-pdf-modal' src={filePath} title='Certificate PDF'></iframe>
        }
      </div>  
    </div>
  </div>
</div>
  )
}
